'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _reactFrameComponent = require('react-frame-component');

var _reactFrameComponent2 = _interopRequireDefault(_reactFrameComponent);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _common = require('../common');

var _EmailTrackingTable = require('./EmailTrackingTable');

var _EmailTrackingTable2 = _interopRequireDefault(_EmailTrackingTable);

var _EmailAttachmentsTable = require('./EmailAttachmentsTable');

var _EmailAttachmentsTable2 = _interopRequireDefault(_EmailAttachmentsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var IFRAME_REF = 'IFRAME';

var GeneratedEmailModal = (_dec = (0, _mobxReact.inject)('CaseStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(GeneratedEmailModal, _Component);

  function GeneratedEmailModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GeneratedEmailModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeneratedEmailModal.__proto__ || Object.getPrototypeOf(GeneratedEmailModal)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'emailDetails', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GeneratedEmailModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.retrieveEmail(this.props.activity.id);
    }
  }, {
    key: 'retrieveEmail',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(emailId) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.CaseStore.fetchEmailDetails(emailId);

              case 2:
                this.emailDetails = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function retrieveEmail(_x) {
        return _ref2.apply(this, arguments);
      }

      return retrieveEmail;
    }()
  }, {
    key: 'injectTargetInHTML',


    /*
      We need to inject a div with an id="" so that the <Frame> content can be injected in it.
      If not, it'll replace the entire <body> content.
    */
    value: function injectTargetInHTML(generatedEmailHtml) {
      var pattern = /<body.*?>/ig;
      var txtHtml = '';

      if (pattern.test(generatedEmailHtml)) {
        txtHtml = generatedEmailHtml.replace(pattern, function (match) {
          return match + '<div id="iframe-content"></div>';
        });
      } else {
        txtHtml = '<div id="iframe-content"></div>' + generatedEmailHtml;
      }

      return txtHtml;
    }
  }, {
    key: 'renderGeneratedEmail',
    value: function renderGeneratedEmail() {
      var iframe_html = this.injectTargetInHTML((0, _get3.default)(this.emailDetails, 'generated_email', '')),
          formattedToField = !(0, _isEmpty3.default)((0, _mobx.toJS)(this.emailDetails.to_emails)) && 'To: ' + this.emailDetails.to_emails.join(', '),
          formattedCcField = !(0, _isEmpty3.default)((0, _mobx.toJS)(this.emailDetails.cc_emails)) && 'CC: ' + this.emailDetails.cc_emails.join(', '),
          formattedBccField = !(0, _isEmpty3.default)((0, _mobx.toJS)(this.emailDetails.bcc_emails)) && 'BCC: ' + this.emailDetails.bcc_emails.join(', ');

      return _react2.default.createElement(
        'div',
        { className: 'iframe-header' },
        _react2.default.createElement(
          'h3',
          null,
          this.emailDetails.subject,
          this.hasAttachments && _react2.default.createElement(_common.Icon, { className: 'attachments', type: 'paperclip' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'info' },
          _react2.default.createElement(
            'div',
            null,
            formattedToField
          ),
          _react2.default.createElement(
            'div',
            null,
            formattedCcField
          ),
          _react2.default.createElement(
            'div',
            null,
            formattedBccField
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'body' },
          _react2.default.createElement(_reactFrameComponent2.default, {
            className: 'iframe-generated-email',
            initialContent: iframe_html,
            mountTarget: '#iframe-content',
            ref: IFRAME_REF
          })
        ),
        this.hasAttachments && _react2.default.createElement(
          'div',
          { className: 'attachments' },
          _react2.default.createElement(_EmailAttachmentsTable2.default, {
            attachments: this.emailDetails.attachments,
            emailId: this.emailDetails.id
          })
        )
      );
    }
  }, {
    key: 'onClose',
    value: function onClose(event) {
      this.props.onClose();
      event && event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Modal2.default,
        { className: 'modal-generated-email side-modal right', show: true, onHide: this.onClose },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'Email Details'
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          (0, _isEmpty3.default)((0, _mobx.toJS)(this.emailDetails)) ? _react2.default.createElement(_common.Loader, { className: 'modal-loader' }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_EmailTrackingTable2.default, { emailDetails: this.emailDetails }),
            this.renderGeneratedEmail()
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            _ButtonToolbar2.default,
            { className: 'pull-right' },
            _react2.default.createElement(
              _Button2.default,
              { bsStyle: 'primary', onClick: this.onClose },
              'Close'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'hasAttachments',
    get: function get() {
      return this.emailDetails.attachments && !!this.emailDetails.attachments.length;
    }
  }]);

  return GeneratedEmailModal;
}(_react.Component), _class3.propTypes = {
  activity: _propTypes2.default.object.isRequired,
  CaseStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'emailDetails', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'hasAttachments', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'hasAttachments'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = GeneratedEmailModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(IFRAME_REF, 'IFRAME_REF', '/app/src/components/page-case/GeneratedEmailModal.js');
  reactHotLoader.register(GeneratedEmailModal, 'GeneratedEmailModal', '/app/src/components/page-case/GeneratedEmailModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/GeneratedEmailModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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